<template>
  <v-dialog
    width="100%"
    max-width="1600px"
    v-model="dialog"
    scrollable
    persistent
    :fullscreen="fullscreen || $vuetify.breakpoint.xs"
    @keydown.esc="dialog = false"
  >
    <v-card :loading="loading">
      <v-system-bar window dark
        ><span v-if="isNew"> neue Rechnung</span>
        <span v-else>Rechnung {{ item.number }}</span
        ><v-divider />
        <v-btn icon @click="fullscreen = !fullscreen"
          ><v-icon>
            {{
              fullscreen ? "mdi-window-restore" : "mdi-window-maximize"
            }}</v-icon
          ></v-btn
        >
        <v-btn icon @click="dialog = false"
          ><v-icon>mdi-close</v-icon></v-btn
        ></v-system-bar
      >
      <v-card-text class="pt-4">
        <v-row v-if="item">
          <v-col cols="12" md="6" lg="5" xl="5">
            <FinanceInvoiceForm v-model="item" @valid="setFormValid" />
          </v-col>
          <v-col cols="12" md="6" lg="7" xl="7">
            <FinanceInvoiceDetailForm v-model="item" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="dialog = false">abbrechen</v-btn>
        <v-spacer />

        <FinanceInvoiceSave
          :item="item"
          :tolerance="tolerance"
          @saved="saved"
          :valid="formValid"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import FinanceInvoiceForm from "common/components/Finance/FinanceInvoiceForm.vue";
import FinanceInvoiceDetailForm from "common/components/Finance/FinanceInvoiceDetailForm.vue";
import FinanceInvoiceSave from "common/components/Finance/FinanceInvoiceSave.vue";

import { createInvoice } from "common/utils/finance.js";

export default defineComponent({
  components: {
    FinanceInvoiceForm,
    FinanceInvoiceDetailForm,
    FinanceInvoiceSave,
  },
  props: { id: {}, page: { type: String, default: "InvoicePending" } },
  data() {
    return {
      loading: false,
      saving: false,
      dialog: true,
      formValid: false,
      fullscreen: false,
      item: createInvoice(),
      tolerance: true,
    };
  },
  computed: {
    gym1OK() {
      if (this.item.details.length < 1) return true;
      if (!this.item.grades[4]) return true;
      const hasOther = this.item.details.some(
        (el) => el.person.grade && el.person.grade.code != "GYM1"
      );
      return !hasOther;
    },
    mixedGradesOK() {
      if (!this.item.account || this.item.account.code === "fieldTrip")
        return true;
      if (this.item.details.length < 1) return true;
      const hasGym1 = this.item.details.some(
        (el) => el.person.grade && el.person.grade.code == "GYM1"
      );
      const hasOther = this.item.details.some(
        (el) => el.person.grade && el.person.grade.code != "GYM1"
      );
      return !(hasGym1 && hasOther);
    },
    copies() {
      return this.item.payee && this.item.payee.code == "schoolFund";
    },
    copiesAmount() {
      return (
        (this.priceGrayscale * this.copiesGrayscale +
          this.priceColor * this.copiesColor) /
        100
      );
    },
    isNew() {
      return !this.id;
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        if (this.isNew) {
          this.$router.push({
            name: "FinanceInvoicesSubmitted",
          });
        } else {
          this.$router.push({
            name: "FinanceInvoicesSubmittedDetail",
            params: { id: this.item.id },
          });
        }
      }
    },
  },
  methods: {
    saved(newId) {
      this.$emit("update");
      this.$router.push({
        name: "FinanceInvoicesSubmittedDetail",
        params: { id: newId },
      });
    },
    setFormValid(valid) {
      this.formValid = valid;
    },
  },

  async created() {
    this.loading = true;
    this.sortOption =
      localStorage.getItem("FinanceInvoiceSortOption") || "schoolClass";
    this.accounts = await this.apiList({
      resource: "finance/invoiceaccount?course",
    });
    this.payees = await this.apiList({ resource: "finance/payee" });
    if (this.isNew) {
      this.item.iban =
        this.$_profilePerson.iban || localStorage.getItem("iban");
    } else {
      this.item = await this.apiGet({
        resource: "finance/invoice",
        id: this.id,
      });
      this.$set(this.item, "nodetails", this.item.details.length == 0);
    }
    this.loading = false;
  },
});
</script>
